import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageToggle } from './LandingChat';

const SAGE   = '#2D6A4F';
const PURPLE = '#6D28D9';

export default function StoryLanding({ onEnter }) {
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: '100vw', height: '100vh', overflow: 'hidden',
        position: 'relative', userSelect: 'none',
        fontFamily: 'sans-serif',
        background: `linear-gradient(145deg, ${SAGE} 0%, #40916C 40%, ${PURPLE} 100%)`,
      }}
    >
      <div style={{
        position: 'absolute', top: '1.4rem', left: 0, right: 0, zIndex: 20,
        display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
        padding: '0 1rem',
      }}>
        <LanguageToggle light />
      </div>

      <div style={{
        height: '100%', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '4rem 2rem 3rem', textAlign: 'center',
      }}>
        <img
          src="/logo192.png"
          alt="Vera"
          style={{ width: 56, height: 56, objectFit: 'contain', marginBottom: '1.5rem', filter: 'brightness(0) invert(1)' }}
        />
        <div style={{
          fontFamily: 'Georgia, serif', fontSize: 'clamp(2rem, 8vw, 2.8rem)',
          fontWeight: 700, color: '#fff', lineHeight: 1.15, marginBottom: '1rem',
          animation: 'fadeUp 0.7s ease both',
        }}>
          {t('story.hero_line1')}
        </div>
        <div style={{
          fontFamily: 'Georgia, serif', fontSize: 'clamp(1.1rem, 4.5vw, 1.4rem)',
          color: 'rgba(255,255,255,0.85)', lineHeight: 1.4, maxWidth: 320,
          animation: 'fadeUp 0.7s 0.25s ease both',
        }}>
          {t('story.hero_line2')}
        </div>

        <div style={{
          marginTop: '2.5rem', display: 'flex', flexDirection: 'column', gap: '0.55rem',
          animation: 'fadeUp 0.7s 0.45s ease both',
        }}>
          {['story.badge_answers', 'story.badge_plan', 'story.badge_alone'].map(k => (
            <div
              key={k}
              style={{
                background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(6px)',
                borderRadius: 20, padding: '0.4rem 1rem',
                color: '#fff', fontSize: '0.85rem',
              }}
            >
              {t(k)}
            </div>
          ))}
        </div>

        <button
          onClick={onEnter}
          style={{
            marginTop: '2.5rem', padding: '0.85rem 2rem',
            background: '#fff', color: PURPLE,
            border: 'none', borderRadius: 30,
            fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
            animation: 'fadeUp 0.7s 0.6s ease both',
          }}
        >
          {t('story.continue')} →
        </button>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
